import React, { ReactNode, useContext, useMemo, useReducer } from "react";
import {
  AllScheduleActions,
  ScheduleState,
  savedFilterState,
  scheduleReducer,
} from "schedule/reducer";

interface ScheduleStoreContext {
  state: ScheduleState;
  dispatch: React.Dispatch<AllScheduleActions>;
}
interface ScheduleStoreProviderProps {
  children: ReactNode;
}

const defaultContext: ScheduleStoreContext = {
  state: savedFilterState,
  dispatch: () => undefined,
};

export const Context =
  React.createContext<ScheduleStoreContext>(defaultContext);
export const StoreProvider = ({ children }: ScheduleStoreProviderProps) => {
  const [state, dispatch] = useReducer(scheduleReducer, savedFilterState);
  const context = useMemo(() => ({ state, dispatch }), [state, dispatch]);
  return <Context.Provider value={context}>{children}</Context.Provider>;
};
export const useStore = () => useContext(Context);
